import { ListBox, Button, Message } from '@flos/react-ui';
import { BranchData, CarbucksReservation } from '../../../types/services';
import './style.scss';
import { CarbucksService } from '../../../services/carBucks';
import { isPrivateUser } from '../../../helpers/topContext';

interface WorkshopListProps {
    workshopList: BranchData[];
    selectedBranchId: string | undefined;
    carbucksReservation: CarbucksReservation | null;
    onSelectWorkshopList: (workshop: BranchData, isSelected: boolean) => void;
}
const WorkshopList = ({
    workshopList,
    selectedBranchId,
    onSelectWorkshopList,
    carbucksReservation
}: WorkshopListProps) => {
    //const [selectedBranchID, setSelectedBranchID] = useState<string>();

    return (
        <>
            {workshopList.length > 0 ? (
                <div className="supman-widget">
                    {workshopList.map((workshop) => {
                        const { address, branchId, email, name, phoneNumber } = workshop;
                        const { streetName, streetNumber, postalCode, city } = address;
                        const isSelected = selectedBranchId === branchId;

                        const isCarbucksWorkshop = workshop.category === 'QUICK_FIX';

                        return (
                            <ListBox
                                key={branchId}
                                className="u-spacing-stack-bottom-5"
                                title={name}
                                subtitle={
                                    <div className="list-box-subtitle">
                                        {isSelected && isCarbucksWorkshop && carbucksReservation && (
                                            <div>
                                                {CarbucksService.prettyFormatReservationDateTime(
                                                    carbucksReservation.reservationStartDatetime
                                                )}
                                            </div>
                                        )}
                                        {streetName} {streetNumber}, {postalCode} {city}
                                    </div>
                                }
                                action={
                                    <Button
                                        minWidth="wider"
                                        theme={isSelected ? 'secondary' : undefined}
                                        onClick={() => {
                                            onSelectWorkshopList(workshop, isSelected);
                                        }}
                                    >
                                        {isCarbucksWorkshop && isPrivateUser()
                                            ? isSelected
                                                ? 'Ret tid'
                                                : 'Book tid'
                                            : isSelected
                                            ? 'Valgt'
                                            : 'Vælg værksted'}
                                    </Button>
                                }
                            >
                                <div className="Box u-bg-brand-05">
                                    {email && (
                                        <>
                                            <div>
                                                <strong>Email</strong>
                                            </div>
                                            <p>{email}</p>
                                        </>
                                    )}
                                    <div>
                                        <strong>Telefonnummer</strong>
                                    </div>
                                    <p>{phoneNumber ? phoneNumber : '-'}</p>
                                </div>
                            </ListBox>
                        );
                    })}
                </div>
            ) : (
                <Message>
                    Vi kunne desværre ikke finde et værksted i dit område. Tjek, at postnummeret er korrekt, eller prøv
                    at søge i et andet område. Du kan også fortsætte uden at vælge et værksted.
                </Message>
            )}
        </>
    );
};

export default WorkshopList;
